/** Customer-facing title for the assigned Flock point of contact (Lead Hub, offer pages, emails). */
export const FLOCK_DIRECTOR_TITLE = 'Exchange Director'
export const FLOCK_DIRECTORS_TITLE = 'Exchange Directors'

export const FLOCK_PHONE_NUMBER = '(720) 703-9992'
export const GOOGLE_PHONE_NUMBER = '(720) 575-0472'
export const REDDIT_PHONE_NUMBER = '(303) 529-1821'
export const CALENDLY_BROKERAGE_URL =
  'https://calendly.com/jonathan-flockhomes/30min'
export const GATSBY_ROOT_DOMAIN =
  process.env.GATSBY_ROOT_DOMAIN || 'https://www.flockhomes.com'
export const FLOCK_EMAIL = 'advisor@flockhomes.com'
export const FLOCK_EXCHANGE_PHONE_NUMBER = '(720) 738-4879'
export const FLOCK_EXCHANGE_EMAIL = 'info@flockexchange.com'
export const INVESTOR_EMAIL = 'clientsupport@flockhomes.com'
export const GOOGLE_MAPS_API_KEY = process.env.GATSBY_GOOGLE_MAPS_API_KEY
export const PHONE_URL = 'tel:+17207039992'
export const PRETTY_PHONE_NUMBER = '(720) 703-9992'

export const CAITLYN_PHONE_NUMBER = '(720) 704-1348'
export const CAITLYN_PHONE_URL = 'tel:+17207041348'

export const JACOB_PHONE_NUMBER = '(804) 567-8194'
export const JACOB_PHONE_URL = 'tel:+18045678194'

export const DANIELLE_EMAIL = 'danielle@flockhomes.com'
export const JACOB_EMAIL = 'jacob@flockhomes.com'

export const MOBILE_BREAKPOINT = '@media (max-width: 767px)'
export const CLIENT_PORTAL_URL =
  process.env.GATSBY_CLIENT_PORTAL_URL || 'https://client.flockhomes.com'

// RECENT_* EOQ DOCUMENTS TO UPDATE
export const RECENT_FUND_PERFORMANCE_URL =
  'https://flock-static-documents.s3.us-east-2.amazonaws.com/production/Quarterly%20Fact%20Sheet%20(2Q26)'
export const RECENT_FUND_FINANCIALS_URL =
  'https://flock-static-documents.s3.us-east-2.amazonaws.com/production/Financial+Overview+(Q4+2025).pdf'
export const RECENT_EARNINGS_CALL_URL =
  'https://flock-static-documents.s3.us-east-2.amazonaws.com/production/Q2%202026%20Investor%20Call'
export const RECENT_EARNINGS_CALL_URL_VIDEO =
  'https://vimeo.com/1214065039/7cd5dbfd80'
export const RECENT_ORG_CHART_URL =
  'https://flock-static-documents.s3.us-east-2.amazonaws.com/production/Flock Homes Organizational Structure'
export const RECENT_LPA_URL =
  'https://flock-static-documents.s3.us-east-2.amazonaws.com/production/Flock Homes - Amended and Restated Agreement of Limited Partnership (April 2025)'
export const RECENT_PPM_URL =
  'https://flock-static-documents.s3.us-east-2.amazonaws.com/production/Flock Homes - Private Placement Memorandum (2025)'
export const RECENT_CA_URL =
  'https://flock-static-documents.s3.us-east-2.amazonaws.com/production/Contribution Agreement (Example)'
export const RECENT_SUBDOCS_URL =
  'https://flock-static-documents.s3.us-east-2.amazonaws.com/production/Flock+Homes+OP+LP+-+Subscription+Booklet+(Contributing+Investors+-+Entities).pdf'
export const RECENT_TAX_BENEFITS_IMPLICATIONS_DECK_URL =
  "https://flock-static-documents.s3.us-east-2.amazonaws.com/production/Tax Benefits & Implications of Flock Homes' Direct 721 Exchange"

export const PROPERTY_STANDARDS_URL =
  'https://flock-static-documents.s3.us-east-2.amazonaws.com/production/Flock%20Standards%20-%20Inspection%20Adjustments'
export const OVERVIEW_URL =
  'https://flock-public-docs.s3.us-east-2.amazonaws.com/Flock+Two+Pager.pdf'
export const DST_OVERVIEW_URL =
  'https://flock-public-docs.s3.us-east-2.amazonaws.com/Flock+Homes+Overview+(1031+DST).pdf'
export const DENVER_POST_ARTICLE_URL =
  'https://www.denverpost.com/2021/04/10/denver-flock-homes-startup-real-estate/'
export const BUSINESS_INSIDER_URL =
  'https://www.businessinsider.com/this-startup-retirement-solution-single-family-rental-landlords-2022-3'
export const ACQUISITION_REPORT_URL =
  'https://flock-public-docs.s3.us-east-2.amazonaws.com/Flock+Acquisition+Report.pdf'
export const TECH_CRUNCH_ARTICLE =
  'https://techcrunch.com/2022/03/24/flock-homes-closes-on-an-a16z-led-26m-series-a/'
export const ANDREESSEN_ARTICLE =
  'https://a16z.com/2022/03/24/investing-in-flock/'
export const KPMG_AUDIT_URL =
  'https://flock-static-documents.s3.us-east-2.amazonaws.com/production/2025+Audited+Financials+-+Flock+Homes+OP+LP+Final+(Redacted).pdf'
export const FLOCK_WEBINAR_231102 =
  'https://flockhomes.docsend.com/view/hynrwwfrt4jpti6m'
export const FLOCK_WEBINAR_241022 =
  'https://flockhomes.docsend.com/view/hebau7ikqbaejenf'

export const GENERIC_OFFER_PAGE_DOCUMENTS = [
  {
    contentUrl:
      'https://flock-static-documents.s3.us-east-2.amazonaws.com/production/Trustpilot+Reviews+Image',
    documentType: 'educational',
    name: 'Trustpilot Reviews',
    uuid: '',
  },
  {
    contentUrl: RECENT_FUND_PERFORMANCE_URL,
    documentType: 'performance',
    name: 'Fact Sheet',
    uuid: '',
  },
  {
    contentUrl: RECENT_FUND_FINANCIALS_URL,
    documentType: 'performance',
    name: 'Fund Financials',
    uuid: '',
  },
  {
    contentUrl: KPMG_AUDIT_URL,
    documentType: 'performance',
    name: 'KPMG Audit',
    uuid: '',
  },
]

// Quarterly Investor Calls
export type InvestorCall = {
  quarter: 1 | 2 | 3 | 4
  year: number
  url: string
  label: string
}

export const INVESTOR_CALLS: InvestorCall[] = [
  {
    quarter: 2,
    year: 2023,
    url: 'https://vimeo.com/850676028/814c557453',
    label: 'Q2 2023 Investor Call',
  },
  {
    quarter: 3,
    year: 2023,
    url: 'https://vimeo.com/882234151/79de8d80c1',
    label: 'Q3 2023 Investor Call',
  },
  {
    quarter: 4,
    year: 2023,
    url: 'https://vimeo.com/908392542/0c01ca938c',
    label: 'Q4 2023 Investor Call',
  },
  {
    quarter: 1,
    year: 2024,
    url: 'https://vimeo.com/938798610/513b2d9c7d',
    label: 'Q1 2024 Investor Call',
  },
  {
    quarter: 2,
    year: 2024,
    url: 'https://vimeo.com/989758072/42b0fdfe4f',
    label: 'Q2 2024 Investor Call',
  },
  {
    quarter: 3,
    year: 2024,
    url: 'https://vimeo.com/1023064774/db05656dd9',
    label: 'Q3 2024 Investor Call',
  },
  {
    quarter: 4,
    year: 2024,
    url: 'https://vimeo.com/1051261605/3dbf890658',
    label: 'Q4 2024 Investor Call',
  },
  {
    quarter: 1,
    year: 2025,
    url: 'https://vimeo.com/1079586111/e853dfcba6',
    label: 'Q1 2025 Investor Call',
  },
  {
    quarter: 2,
    year: 2025,
    url: 'https://vimeo.com/1105282770/85e5c7faad',
    label: 'Q2 2025 Investor Call',
  },
  {
    quarter: 3,
    year: 2025,
    url: 'https://vimeo.com/1130295271/cc49a3c283',
    label: 'Q3 2025 Investor Call',
  },
  {
    quarter: 4,
    year: 2025,
    url: 'https://vimeo.com/1158588309/b0c84bae0e',
    label: 'Q4 2025 Investor Call',
  },
  {
    quarter: 1,
    year: 2026,
    url: 'https://vimeo.com/1187101731/8c75d426a7',
    label: 'Q1 2026 Investor Call',
  },
  {
    quarter: 2,
    year: 2026,
    url: 'https://vimeo.com/1214065039/7cd5dbfd80',
    label: 'Q2 2026 Investor Call',
  },
]

/**
 * Helper function to get investor call URL by name
 * @param name - The name string from the document (e.g., "Q2 2023 Investor Call")
 * @returns The URL for the matching investor call, or undefined if not found
 */
export const getInvestorCallUrl = (name: string): string | undefined => {
  const investorCall = INVESTOR_CALLS.find((call) => name.includes(call.label))
  return investorCall?.url
}

// Quarterly Fact Sheets
export type QuarterlyFactSheet = {
  quarter: 1 | 2 | 3 | 4
  year: number
  url: string
  label: string
}

export const QUARTERLY_FACT_SHEETS: QuarterlyFactSheet[] = [
  {
    quarter: 1,
    year: 2023,
    url: 'https://flock-static-documents.s3.us-east-2.amazonaws.com/production/Flock Quarterly Fact Sheet (1Q23)',
    label: 'Q1 2023 Fact Sheet',
  },
  {
    quarter: 2,
    year: 2023,
    url: 'https://flock-static-documents.s3.us-east-2.amazonaws.com/production/Flock Quarterly Fact Sheet (2Q23)',
    label: 'Q2 2023 Fact Sheet',
  },
  {
    quarter: 3,
    year: 2023,
    url: 'https://flock-static-documents.s3.us-east-2.amazonaws.com/production/Flock Quarterly Fact Sheet (3Q23)',
    label: 'Q3 2023 Fact Sheet',
  },
  {
    quarter: 4,
    year: 2023,
    url: 'https://flock-static-documents.s3.us-east-2.amazonaws.com/production/Flock Quarterly Fact Sheet (4Q23)',
    label: 'Q4 2023 Fact Sheet',
  },
  {
    quarter: 1,
    year: 2024,
    url: 'https://flock-static-documents.s3.us-east-2.amazonaws.com/production/Flock Quarterly Fact Sheet (1Q24)',
    label: 'Q1 2024 Fact Sheet',
  },
  {
    quarter: 2,
    year: 2024,
    url: 'https://flock-static-documents.s3.us-east-2.amazonaws.com/production/Flock Quarterly Fact Sheet (2Q24)',
    label: 'Q2 2024 Fact Sheet',
  },
  {
    quarter: 3,
    year: 2024,
    url: 'https://flock-static-documents.s3.us-east-2.amazonaws.com/production/Flock Quarterly Fact Sheet (3Q24)',
    label: 'Q3 2024 Fact Sheet',
  },
  {
    quarter: 4,
    year: 2024,
    url: 'https://flock-static-documents.s3.us-east-2.amazonaws.com/production/Flock+Quarterly+Fact+Sheet+(4Q24).pdf',
    label: 'Q4 2024 Fact Sheet',
  },
  {
    quarter: 1,
    year: 2025,
    url: 'https://flock-static-documents.s3.us-east-2.amazonaws.com/production/Quarterly+Fact+Sheet+(1Q25)',
    label: 'Q1 2025 Fact Sheet',
  },
  {
    quarter: 2,
    year: 2025,
    url: 'https://flock-static-documents.s3.us-east-2.amazonaws.com/production/Flock+Quarterly+Fact+Sheet+(2Q25).pdf',
    label: 'Q2 2025 Fact Sheet',
  },
  {
    quarter: 3,
    year: 2025,
    url: 'https://flock-static-documents.s3.us-east-2.amazonaws.com/production/Flock+Quarterly+Fact+Sheet+(3Q25).pdf',
    label: 'Q3 2025 Fact Sheet',
  },
  {
    quarter: 4,
    year: 2025,
    url: 'https://flock-static-documents.s3.us-east-2.amazonaws.com/production/Flock+Quarterly+Fact+Sheet+(4Q25).pdf',
    label: 'Q4 2025 Fact Sheet',
  },
  {
    quarter: 1,
    year: 2026,
    url: 'https://flock-static-documents.s3.us-east-2.amazonaws.com/production/Quarterly%20Fact%20Sheet%20(1Q26)',
    label: 'Q1 2026 Fact Sheet',
  },
  {
    quarter: 2,
    year: 2026,
    url: 'https://flock-static-documents.s3.us-east-2.amazonaws.com/production/Quarterly%20Fact%20Sheet%20(2Q26)',
    label: 'Q2 2026 Fact Sheet',
  },
]

/**
 * Helper function to get fact sheet URL by quarter and year
 * @param quarter - Quarter number (1-4)
 * @param year - Year (e.g., 2025)
 * @returns The URL for the matching fact sheet, or undefined if not found
 */
export const getFactSheetUrl = (
  quarter: 1 | 2 | 3 | 4,
  year: number
): string | undefined => {
  const factSheet = QUARTERLY_FACT_SHEETS.find(
    (s) => s.quarter === quarter && s.year === year
  )
  return factSheet?.url
}
